import { popoverAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

export const PopoverTheme = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    content: {
      _focusVisible: {
        boxShadow: "none",
        w: "auto",
      },
      background: "bg.panelBg",
    },
  }),
});
